var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MasonryObras',{attrs:{"obras":_vm.obras}})
}
var staticRenderFns = []

export { render, staticRenderFns }